let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3IjdC")).then(() => parcelRequire('er8TA'));